<div class="modal-body relative h-full">
  <header class="header modal-header flex flex-col gap-2 place-content-between sticky bg-white top-0 z-50">
    <div class="flex justify-between">
      <h2 class="modal-headline" *ngIf="downloadType">{{ downloadType }}</h2>
      <h2 class="modal-headline" *ngIf="!downloadType">Download</h2>
      <button mat-icon-button mat-dialog-close class="button-close">
        <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
        <span class="sr-only" i18n>Close</span>
      </button>
    </div>
  </header>

  <div class="modal-main flex-1">
    <form [formGroup]="downloadForm" class="h-full">
      <div class="flex flex-col bg-white h-full w-full">
        @if (downloadData) {
          <div *ngIf="mandatoryFieldsFlag" class="modal-main-config">
            <!--todo: check only for detailed buyout rights popup (mandatoryPurposeFlag)-->
            <div *ngIf="CustomClients.Vorwerk === brandingKey" class="flex flex-col sm:w-1/2">
              <span class="field-label" i18n>License region</span>
              <sp-mat-select-search
                formControlName="licenseRegion"
                [dataSource]="licenseRegion"
                [placeholder]="PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE"
                [config]="{ search: true, multiple: true, enableSecondPartLabel: false }"
                [attrDataTestId]="'licenseRegion'"
                (removeChip)="removeChips($event, 'licenseRegion')"
                (selectedChange)="onValueChange($event)"
              ></sp-mat-select-search>
            </div>
            <div class="flex flex-col sm:w-1/2" *ngIf="![CustomClients.WestLotto, CustomClients.Standard].includes(brandingKey)">
              <span class="field-label" i18n>Purpose of download*</span>
              <sp-mat-select-search
                formControlName="purpose"
                [dataSource]="allPurposes"
                [placeholder]="PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE"
                [config]="{ search: true, multiple: true, enableMatOptGroup: true, enableSecondPartLabel: false, required: mandatoryFieldsFlag, requiredText: 'Purpose is required' }"
                [attrDataTestId]="'purpose'"
                (removeChip)="removeChips($event, 'purpose')"
              ></sp-mat-select-search>
            </div>
          </div>
          <div class="modal-main-content">
            <div class="input-box" style="overflow: scroll">
              <sp-mat-tree
                (nodeList)="downloadForm.get('selected')?.setValue($event)"
                [matTreeDataSource]="downloadData"
                [selectAllCheckboxDefault]="matTreeCheckbox"
                [required]="isMatTreeSelected"
                [showExpandCollapse]="true"
                [showBorder]="true"
                [showExpiryDate]="showExpiryDate"
              >
              </sp-mat-tree>
              <mat-error *ngIf="isMatTreeSelected" i18n>This Field is required</mat-error>
            </div>
            <div class="actions h-min w-auto" *ngIf="!(AnyAsset | can: 'downloadonlylowres')">
              <div class="flex flex-col lg:w-full" *ngIf="[CustomClients.Standard, CustomClients.Vorwerk].includes(brandingKey)">
                <span class="field-label" i18n>Select files</span>
                <sp-mat-select-search
                  formControlName="selectedOptions"
                  [dataSource]="allSelectFileOptions"
                  [placeholder]="PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE"
                  [config]="{ multiple: true, sortDataSource: false }"
                  [attrDataTestId]="'asset-download_select'"
                  (selectedChange)="onSelectedChange($event, downloadData)"
                  (removeChip)="removeChips($event, 'selectedOptions', downloadData)"
                ></sp-mat-select-search>
              </div>
              <button
                *ngIf="![CustomClients.Standard, CustomClients.Vorwerk].includes(brandingKey)"
                type="button"
                (click)="checkOriginalFiles(downloadData)"
                [disabled]="false"
                class="button-primary ml-auto whitespace-nowrap"
                [attr.data-test-id]="'asset-download_button_select'"
                i18n
              >
                Select original files
              </button>
            </div>
          </div>
        } @else {
          <div class="flex flex-col items-center justify-center h-full">
            <mat-spinner [diameter]="60" color="warn"></mat-spinner>
          </div>
        }
      </div>
    </form>
  </div>

  <div class="modal-footer flex flex-col w-full">
    <mat-error *ngIf="errorMsg" class="w-full !flex items-center">
      <mat-icon class="material-icons-outlined mat-error !text-[1.3rem]" i18n-matTooltip matTooltip="Warning">warning_amber</mat-icon>
      <span [innerHTML]="errorMsg"></span>
    </mat-error>

    <div class="modal-footer-wrapper">
      <div *ngIf="brandingKey === CustomClients.LufthansaMediacenter || brandingKey === CustomClients.LufthansaMedialounge; then content; else other_content"></div>
      <ng-template #content>
        <mat-checkbox class="w-full" *ngIf="env.termsConditionsPopup?.onAssetDownload" (change)="checkboxClick($event.checked)" [checked]="downloadForm.get('expiryAndTerms')?.value">
          <span>
            <ng-container i18n>Yes, I accept the</ng-container>&nbsp;<span class="underline cursor-pointer" (click)="openTerms($event)" i18n>terms & conditions</span>&nbsp;<span i18n>for</span>&nbsp;
            <ng-template [ngIf]="brandingKey === CustomClients.LufthansaMediacenter">Media Center.</ng-template>
            <ng-template [ngIf]="brandingKey === CustomClients.LufthansaMedialounge">Media Lounge.</ng-template>
          </span>
        </mat-checkbox>
      </ng-template>
      <ng-template #other_content>
        <ng-template [ngIf]="[CustomClients.SEAT].includes(brandingKey)">
          <div class="flex flex-col">
            <div>
              <p i18n class="text-sm text-gray-500">
                Since August 2026, all content that has been created or modified using AI must be clearly labeled. Therefore, if you use images from the media library, you should first familiarize
                yourself with the new EU AI Act and ensure compliance with the current legal requirements. In addition, please follow the corporate identity (CI) guidelines regarding the use of AI
                labels, as well as the local legal guidance. You can find more information about the AI status of a specific image in the Image Index Files. Alternatively, you can contact the person
                responsible for buyout-related questions, whose details can be found under the usage rights of the respective image.
              </p>
            </div>
            <mat-checkbox class="w-full" *ngIf="env.termsConditionsPopup?.onAssetDownload" (change)="checkboxEUAIActClick($event.checked)" [checked]="downloadForm.get('euAIAct')?.value">
              <span i18n class="text-sm text-gray-500">I am familiar with the requirements of the</span> <span class="underline text-[0.8rem] text-gray-500"> EU AI Act </span>
              <span i18n class="text-sm text-gray-500">and will ensure compliance with them when using any content.</span>
            </mat-checkbox>
            <mat-checkbox class="w-full" *ngIf="env.termsConditionsPopup?.onAssetDownload" (change)="checkboxClick($event.checked)" [checked]="downloadForm.get('expiryAndTerms')?.value">
              <span class="text-sm text-gray-500"
                ><ng-container i18n>I accept the</ng-container>&nbsp;<span class="underline cursor-pointer text-[0.8rem]" (click)="openTerms($event)" i18n>Terms and conditions</span>.</span
              >
            </mat-checkbox>
          </div>
        </ng-template>
        <ng-template [ngIf]="brandingKey === CustomClients.Standard">
          <mat-checkbox class="w-full" (change)="checkboxClick($event.checked)" [checked]="downloadForm.get('expiryAndTerms')?.value">
            <span><ng-container i18n>When using the asset, please comply with the current rights of use (licensee, scope of license).</ng-container></span>
          </mat-checkbox>
        </ng-template>
        <ng-template [ngIf]="![CustomClients.SEAT, CustomClients.Standard].includes(brandingKey)">
          <mat-checkbox class="w-full" *ngIf="env.termsConditionsPopup?.onAssetDownload" (change)="checkboxClick($event.checked)" [checked]="downloadForm.get('expiryAndTerms')?.value">
            <span>
              <ng-container i18n>I accept the</ng-container>&nbsp;<span class="underline cursor-pointer" (click)="openTerms($event)" i18n>{{
                env.termsConditionsPopup?.linkText || 'expiry and usage terms'
              }}</span>
            </span>
          </mat-checkbox>
        </ng-template>
      </ng-template>
      <div class="flex flex-col items-end">
        <button (click)="onSubmit()" class="button-primary ml-auto bg-white" mat-flat-button [attr.data-test-id]="'asset-upload_button_upload'" [disabled]="downloadForm.invalid">
          <ng-container i18n>Download</ng-container>
          <mat-icon class="material-icons-outlined ml-2">file_download</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
